import QuizContent from "./QuizContent";

function Main() {
  return (
    <div className="p-10 md:p-16">
      <h1 className="text-3xl md:text-5xl uppercase text-qpblue-400 font-extrabold text-center mt-4">
        查询报价
      </h1>
      <p className="hidden md:block text-center mt-6 font-extrabold text-gray-600">
        请尽可能地告诉我们您的项目与想法,
        <br />
        您只需不到2分钟的时间来填写此表单,
        <br />
        我们将在24小时内与您联系。
      </p>
      <QuizContent />
    </div>
  );
}

export default Main;
